/**
 * Legal document library — KVKK, Privacy Policy, Terms, Cookies.
 * Content is intentionally in-code (not CMS-managed) so it always ships with
 * the site. Admin can override individual paragraphs by editing this file.
 * Values are Localized objects: { tr, en, ar }.
 */

const L = (tr, en, ar) => ({ tr, en, ar });

const HQ_ADDRESS =
  "Mustafa Kemal Paşa Mahallesi, Gerçek Sokak No: 2, İç Kapı No: 3, Arnavutköy / İstanbul";
const HQ_EMAIL = "info@firatconstruction.com";
const HQ_PHONE = "0212 597 85 75";

export const LEGAL_DOCS = {
  kvkk: {
    key: "kvkk",
    title: L(
      "KVKK Aydınlatma Metni",
      "GDPR / KVKK Notice",
      "إشعار حماية البيانات (KVKK)"
    ),
    intro: L(
      "6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında veri sorumlusu sıfatıyla siz değerli ziyaretçilerimizi bilgilendirmek amacıyla hazırlanmıştır.",
      "This notice is prepared in accordance with Turkey’s Personal Data Protection Law No. 6698 (KVKK) as we act as the data controller for your information.",
      "تم إعداد هذا الإشعار وفقاً لقانون حماية البيانات الشخصية التركي رقم 6698."
    ),
    sections: [
      {
        heading: L("1. Veri Sorumlusu", "1. Data Controller", "1. مسؤول البيانات"),
        body: L(
          `Fırat Construction Yapı A.Ş. ("Şirket") veri sorumlusudur.\nAdres: ${HQ_ADDRESS}\nE-posta: ${HQ_EMAIL}\nTelefon: ${HQ_PHONE}`,
          `Fırat Construction Yapı Inc. ("Company") is the data controller.\nAddress: ${HQ_ADDRESS}\nEmail: ${HQ_EMAIL}\nPhone: ${HQ_PHONE}`,
          `شركة فرات للإنشاءات ("الشركة") هي المسؤول عن البيانات.\nالعنوان: ${HQ_ADDRESS}\nالبريد: ${HQ_EMAIL}\nالهاتف: ${HQ_PHONE}`
        ),
      },
      {
        heading: L(
          "2. Toplanan Kişisel Veriler",
          "2. Personal Data Collected",
          "2. البيانات التي نجمعها"
        ),
        body: L(
          "İletişim formu, kariyer başvurusu ve iş ortaklığı taleplerinizle paylaştığınız; ad-soyad, e-posta, telefon, açık adres, özgeçmiş, ilgili proje/gayrimenkul detayları ile IP adresi, çerez ve tarayıcı bilgileri gibi teknik verileri işleriz.",
          "We process personal data you share via contact forms, career or partnership requests — including full name, email, phone, address, resume, project or property details, as well as technical data such as IP address, cookies, and browser information.",
          "نعالج بياناتك التي تشاركها عبر نماذج التواصل والوظائف والشراكة — بما في ذلك الاسم والبريد الإلكتروني والهاتف والعنوان والسيرة الذاتية وتفاصيل المشروع/العقار."
        ),
      },
      {
        heading: L("3. İşleme Amaçları", "3. Processing Purposes", "3. أغراض المعالجة"),
        body: L(
          "Kişisel verileriniz; taleplerinize dönüş yapmak, sözleşme kurulması ve ifası, iş başvurularının değerlendirilmesi, gayrimenkul alım-satım süreçlerinin yürütülmesi, hukuki yükümlülüklerin yerine getirilmesi, meşru menfaatlerimiz kapsamında iletişim, pazarlama ve raporlama faaliyetleri amacıyla işlenir.",
          "Your data is processed to respond to your requests, execute contracts, evaluate job applications, manage real-estate transactions, comply with legal obligations, and conduct communication, marketing, and reporting activities based on our legitimate interests.",
          "تُعالج بياناتك للرد على طلباتك وتنفيذ العقود وتقييم طلبات التوظيف وإدارة معاملات العقارات والامتثال للالتزامات القانونية."
        ),
      },
      {
        heading: L(
          "4. Aktarılan Kişiler ve Amacı",
          "4. Data Sharing",
          "4. مشاركة البيانات"
        ),
        body: L(
          "Verileriniz; yalnızca yasal zorunluluk halinde yetkili kamu kurumları, iş ortaklarımız ile hizmet aldığımız (CRM, e-posta, bulut altyapı, çağrı merkezi) tedarikçilerimizle paylaşılabilir. Uluslararası aktarım gerçekleşmesi durumunda gerekli güvenceler alınır.",
          "Your data may be shared only when legally required with public authorities, business partners, and service providers (CRM, email, cloud, call-center). Adequate safeguards are ensured for any international transfer.",
          "قد تتم مشاركة بياناتك عند الحاجة القانونية مع السلطات المختصة وشركائنا ومزودي الخدمات (CRM، البريد، السحابة، مركز الاتصال)."
        ),
      },
      {
        heading: L("5. Saklama Süresi", "5. Retention", "5. مدة الاحتفاظ"),
        body: L(
          "Kişisel verileriniz; ilgili mevzuatın öngördüğü asgari süreler ve şirketimizin meşru menfaati kapsamında en fazla 10 yıla kadar saklanır. Bu süre sonunda anonimleştirilir veya silinir.",
          "Personal data is retained for the minimum period required by law, up to 10 years under our legitimate interests. After that period, data is anonymized or erased.",
          "يتم الاحتفاظ بالبيانات للفترة الدنيا المطلوبة قانوناً حتى 10 سنوات ثم تُحذف أو تُجعل مجهولة."
        ),
      },
      {
        heading: L(
          "6. Haklarınız (KVKK m. 11)",
          "6. Your Rights (KVKK Art. 11)",
          "6. حقوقك"
        ),
        body: L(
          "Verilerinize erişme, düzeltilmesini isteme, silinmesini veya anonimleştirilmesini talep etme, işlemeye itiraz etme ve zararın giderilmesini isteme haklarınız bulunmaktadır. Başvurularınızı " +
            HQ_EMAIL +
            " adresine iletebilirsiniz.",
          "You have the right to access, rectify, erase or anonymize your data, object to processing, and seek compensation for damages. Requests can be sent to " +
            HQ_EMAIL +
            ".",
          "لديك الحق في الوصول إلى بياناتك وتصحيحها أو حذفها أو الاعتراض على المعالجة. أرسل طلبك إلى " +
            HQ_EMAIL +
            "."
        ),
      },
      {
        heading: L("7. Değişiklikler", "7. Changes", "7. التعديلات"),
        body: L(
          "Bu Aydınlatma Metni gerektiğinde güncellenebilir; güncel versiyon daima bu sayfada yayınlanır. Son güncelleme: 2026.",
          "This notice may be updated as required; the latest version is always published on this page. Last updated: 2026.",
          "قد يتم تحديث هذا الإشعار عند الحاجة؛ الإصدار الأخير منشور دائماً هنا. آخر تحديث: 2026."
        ),
      },
    ],
  },

  gizlilik: {
    key: "gizlilik",
    title: L("Gizlilik Politikası", "Privacy Policy", "سياسة الخصوصية"),
    intro: L(
      "Fırat Construction Yapı A.Ş. olarak gizliliğinize saygı duyuyoruz. Bu politika; sitemizi ziyaret eden ve hizmetlerimizden yararlanan kişilerin verilerini nasıl işlediğimizi açıklar.",
      "At Fırat Construction Yapı Inc. we respect your privacy. This policy explains how we handle information from visitors and clients.",
      "نحن نحترم خصوصيتك. توضح هذه السياسة كيفية معالجتنا للمعلومات من الزوار والعملاء."
    ),
    sections: [
      {
        heading: L("Bilgi Toplama", "Information We Collect", "المعلومات التي نجمعها"),
        body: L(
          "İletişim, kariyer ve iş ortaklığı formları üzerinden gönderdiğiniz iletişim bilgileri; ziyaret ettiğiniz sayfalar, cihaz türü ve genel konum gibi otomatik olarak toplanan teknik veriler.",
          "Contact information you submit through forms, plus technical data such as pages viewed, device type, and approximate location collected automatically.",
          "معلومات الاتصال التي تقدمها عبر النماذج بالإضافة إلى بيانات تقنية تُجمع تلقائياً."
        ),
      },
      {
        heading: L("Kullanım", "How We Use It", "كيفية الاستخدام"),
        body: L(
          "Bilgilerinizi taleplerinize dönüş yapmak, hizmetlerimizi iyileştirmek, site trafiğini ölçmek ve pazarlama iletişimi için (izniniz varsa) kullanırız.",
          "We use information to respond to your requests, improve our services, measure traffic, and — with your consent — for marketing communications.",
          "نستخدم المعلومات للرد على طلباتك وتحسين خدماتنا وقياس حركة الموقع."
        ),
      },
      {
        heading: L(
          "Üçüncü Taraf Servisler",
          "Third-Party Services",
          "خدمات الأطراف الثالثة"
        ),
        body: L(
          "Sitemiz; Bitrix24 CRM iletişim formu, Google Fonts, harita servisleri gibi üçüncü taraf servisleri kullanır. Bu servisler kendi gizlilik politikaları çerçevesinde çalışır.",
          "Our site uses third-party services such as Bitrix24 CRM forms, Google Fonts, and mapping services, each governed by their own privacy policies.",
          "يستخدم موقعنا خدمات طرف ثالث مثل نماذج Bitrix24 وGoogle Fonts وخرائط."
        ),
      },
      {
        heading: L("Veri Güvenliği", "Security", "أمن البيانات"),
        body: L(
          "Verilerinizi yetkisiz erişime karşı korumak için SSL şifreleme, erişim kontrolü ve düzenli güvenlik denetimleri uygularız.",
          "We employ SSL encryption, access controls, and regular security audits to protect your data.",
          "نستخدم تشفير SSL وضوابط الوصول والتدقيقات الأمنية المنتظمة لحماية بياناتك."
        ),
      },
      {
        heading: L("İletişim", "Contact", "التواصل"),
        body: L(
          "Gizlilikle ilgili tüm sorularınız için " + HQ_EMAIL + " adresi üzerinden bize ulaşabilirsiniz.",
          "For any privacy-related questions please contact " + HQ_EMAIL + ".",
          "لأي أسئلة تتعلق بالخصوصية، تواصل معنا عبر " + HQ_EMAIL + "."
        ),
      },
    ],
  },

  kullanim: {
    key: "kullanim",
    title: L("Kullanım Koşulları", "Terms of Use", "شروط الاستخدام"),
    intro: L(
      "firatconstruction.com sitesini (\"Site\") kullanarak aşağıdaki koşulları kabul etmiş sayılırsınız.",
      "By using firatconstruction.com (the \"Site\") you accept the following terms.",
      "باستخدام موقع firatconstruction.com فإنك توافق على الشروط التالية."
    ),
    sections: [
      {
        heading: L("Fikri Mülkiyet", "Intellectual Property", "الملكية الفكرية"),
        body: L(
          "Site'de yer alan tüm metinler, görseller, videolar, logolar ve tasarımlar Fırat Construction Yapı A.Ş.'ye aittir. İzinsiz kopyalanamaz, çoğaltılamaz veya dağıtılamaz.",
          "All text, images, videos, logos, and designs on the Site are owned by Fırat Construction Yapı Inc. Unauthorized copying, reproduction, or distribution is prohibited.",
          "جميع النصوص والصور والفيديوهات والشعارات مملوكة للشركة. النسخ أو التوزيع غير المصرح به ممنوع."
        ),
      },
      {
        heading: L("Sorumluluğun Sınırlandırılması", "Limitation of Liability", "حدود المسؤولية"),
        body: L(
          "Site içeriği bilgilendirme amaçlıdır; herhangi bir yatırım tavsiyesi veya sözleşme oluşturmaz. Şirket, içerik doğruluğu için gayret göstermekle birlikte kesin taahhütte bulunmaz.",
          "Content is informational only and does not constitute investment advice or a binding contract. While we strive for accuracy we make no guarantees.",
          "المحتوى للأغراض المعلوماتية فقط ولا يعتبر نصيحة استثمارية أو عقداً ملزماً."
        ),
      },
      {
        heading: L("Kullanıcı Davranışı", "User Conduct", "سلوك المستخدم"),
        body: L(
          "Ziyaretçilerimiz siteyi hukuka uygun şekilde kullanmayı, spam, otomatik veri toplama veya güvenlik açıklarından yararlanma girişimlerinde bulunmamayı kabul eder.",
          "Visitors agree to use the site lawfully and not to attempt spam, scraping, or exploitation of security vulnerabilities.",
          "يوافق الزوار على استخدام الموقع بشكل قانوني وعدم محاولة الرسائل المزعجة أو استغلال الثغرات."
        ),
      },
      {
        heading: L("Yürürlük", "Governing Law", "القانون المطبق"),
        body: L(
          "Bu koşullar Türkiye Cumhuriyeti hukukuna tabidir. Uyuşmazlıklar İstanbul mahkemelerinde çözülür.",
          "These terms are governed by Turkish law. Disputes are resolved in Istanbul courts.",
          "تخضع هذه الشروط للقانون التركي وتُحل النزاعات في محاكم إسطنبول."
        ),
      },
    ],
  },

  cerez: {
    key: "cerez",
    title: L("Çerez Politikası", "Cookie Policy", "سياسة ملفات تعريف الارتباط"),
    intro: L(
      "Bu Çerez Politikası, sitemizde kullanılan çerezler ve benzeri teknolojiler hakkında bilgi verir.",
      "This Cookie Policy explains the cookies and similar technologies used on our site.",
      "توضح هذه السياسة ملفات تعريف الارتباط والتقنيات المماثلة المستخدمة على موقعنا."
    ),
    sections: [
      {
        heading: L("Çerez Nedir?", "What Are Cookies?", "ما هي؟"),
        body: L(
          "Çerezler; ziyaret ettiğiniz web sitelerinin tarayıcınıza yerleştirdiği küçük metin dosyalarıdır. Site'nin sizin için doğru çalışması ve deneyiminizin iyileştirilmesi için kullanılır.",
          "Cookies are small text files placed on your browser by websites you visit. They help the site function correctly and improve your experience.",
          "ملفات تعريف الارتباط هي ملفات نصية صغيرة تُوضع على متصفحك."
        ),
      },
      {
        heading: L("Kullandığımız Çerez Türleri", "Cookie Types", "الأنواع"),
        body: L(
          "• Zorunlu çerezler — Site'nin temel işlevleri için gereklidir\n• Analitik çerezler — anonim kullanım istatistikleri toplar\n• Pazarlama çerezleri — kampanyalarımızın performansını ölçer\n• Üçüncü taraf çerezler — Bitrix24 form, harita, video servisleri",
          "• Essential cookies — required for basic site function\n• Analytics cookies — anonymous usage statistics\n• Marketing cookies — measure campaign performance\n• Third-party cookies — Bitrix24 forms, maps, video services",
          "• أساسية\n• تحليلية\n• تسويقية\n• طرف ثالث"
        ),
      },
      {
        heading: L("Çerez Yönetimi", "Managing Cookies", "الإدارة"),
        body: L(
          "Tarayıcı ayarlarınızdan çerezleri istediğiniz zaman engelleyebilir veya silebilirsiniz. Bunu yapmanız halinde Site'nin bazı bölümleri düzgün çalışmayabilir.",
          "You can block or delete cookies via your browser settings at any time. Doing so may affect certain parts of the site.",
          "يمكنك حظر ملفات تعريف الارتباط أو حذفها من إعدادات المتصفح في أي وقت."
        ),
      },
    ],
  },
};

/* Public directory used in the Footer / cookie banner */
export const LEGAL_LINKS = [
  { slug: "kvkk", key: "kvkk" },
  { slug: "gizlilik", key: "gizlilik" },
  { slug: "kullanim", key: "kullanim" },
  { slug: "cerez", key: "cerez" },
];
